import { defaultTheme } from "react-admin";
import indigo from '@mui/material/colors/indigo';
import pink from '@mui/material/colors/pink';
import red from '@mui/material/colors/red';

const theme = {
  ...defaultTheme,
  palette: {
    primary: indigo,
    secondary: pink,
    error: red,
    contrastThreshold: 3,
    tonalOffset: 0.2,
  },
  components: {
    ...defaultTheme.components,
    MuiList: {
      defaultProps: {
        dense: true as any,
      }
    },
    MuiMenuItem: {
      defaultProps: {
        dense: true as any,
      }
    },
    MuiTable: {
      defaultProps: {
        size: "small" as any,
      },
    },
    MuiButton: {
      defaultProps: {
        size: 'small' as any,
      }
    },
    MuiButtonGroup: {
      defaultProps: {
        size: 'small' as any,
      }
    },
    MuiCheckbox: {
      defaultProps: {
        size: 'small' as any,
      }
    },
    MuiFab: {
      defaultProps: {
        size: 'small' as any,
      }
    },
    MuiFormControl: {
      defaultProps: {
        margin: 'dense' as any,
        size: 'small' as any,
      }
    },
    MuiFormHelperText: {
      defaultProps: {
        margin: 'dense' as any,
      }
    },
    MuiIconButton: {
      defaultProps: {
        size: 'small' as any,
      }
    },
    MuiInputBase: {
      defaultProps: {
        margin: 'dense' as any,
      }
    },
    MuiInputLabel: {
      defaultProps: {
        margin: 'dense' as any,
      }
    },
    MuiRadio: {
      defaultProps: {
        size: 'small' as any,
      }
    },
    MuiSwitch: {
      defaultProps: {
        size: 'small' as any,
      }
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          padding: '1px 2px',
        }
      }
    },
    // MuiTextField: {
    //   defaultProps: {
    //     margin: 'dense' as any,
    //     size: 'small' as any,
    //   }
    // },
    RaChipField: {
      styleOverrides: {
        root: {
          "&.RaChipField-chip": {
            margin: 0,
            height: '24px',
          },
          "& .MuiChip-label": {
            paddingLeft: "6px",
            paddingRight: "6px",
          }
        }
      }
    },
    RaAppBar: {
      styleOverrides: {
        root: {
          "& .MuiToolbar-root": {
          }
        }
      }
    },
    RaDatagrid: {
      styleOverrides: {
        root: {
          width: '100%',
        }
      }
    },
    RaLayout: {
      styleOverrides: {
        root: {
          backgroundColor: "#F0F0EE",
        }
      }
    },
    RaSidebar: {
      styleOverrides: {
        root: {
          "& .MuiMenuItem-root": {
            color: "#000",
            "& .MuiTypography-root": {
              color: "#000",
            },
            "& .MuiListItemIcon-root": {
              color: "#000",
            },
            "&.RaMenuItemLink-active": {
              color: "#60583E",
              "& .MuiListItemIcon-root ": {
                color: "#60583E",
              },
            },
          },
        }
      }
    },
  }
}

export default theme;
